import React from 'react';
import { Copy, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import { MAX_NUMBER_OF_CHILD_ACCOUNTS } from 'src/components/enterprise/Parents/constants';

export const ChildAccountCreationHeader: React.FC = () => {
  const instructionalText = `You can add up to ${MAX_NUMBER_OF_CHILD_ACCOUNTS} child accounts under a parent account. (If you
          have more, please create another parent account). You can name child
          accounts by location, office, department, or whatever you want. The
          name will be visible to employees and on invoices.`;
  return (
    <>
      <Stack y="sm">
        <Heading variant="h5">Add child accounts</Heading>
      </Stack>

      <Stack y="lg">
        <Copy variant="body">{instructionalText}</Copy>
      </Stack>
    </>
  );
};
